import * as React from 'react';
import { useEffect } from 'react';
import { CheckoutContext, Steps } from './utils/CheckoutContext';
import { useWiderThan } from '@weddingspot/ws-core-components';

const { useStepper, Stepper, useStep } = require('@cvent/carina-wizard');

const styles = require('./CheckOutPage.module.scss');

const StepperWrapper = () => {
    const isSmallScreen = !useWiderThan(560);
    const { step } = React.useContext(CheckoutContext);
    const { stepperProps } = useStepper();
    const { setStepperProps: setStepperProps1, goForward: goForward1 } = useStep({ id: '1' });
    const { setStepperProps: setStepperProps2, goForward: goForward2 } = useStep({ id: '2' });
    const { setStepperProps: setStepperProps3, goForward: goForward3 } = useStep({ id: '3' });
    const { setStepperProps: setStepperProps4 } = useStep({ id: '4' });

    useEffect(() => {
        setStepperProps1({
            name: (
                <>
                    <h3>Message Venues</h3>
                </>
            ),
        });
        setStepperProps2({
            name: (
                <>
                    <h3>Message More Venues</h3>
                    <span>*optional</span>
                </>
            ),
        });
        setStepperProps3({
            name: (
                <>
                    <h3>Reserve Hotel Rooms</h3>
                    <span>*optional</span>
                </>
            ),
        });
        setStepperProps4({
            name: (
                <>
                    <h3>Done</h3>
                </>
            ),
        });
    }, []);

    useEffect(() => {
        if (step === Steps.MoreVenues) {
            goForward1();
        }
        if (step === Steps.HotelsRecommendations) {
            goForward2();
        }
        if (step === Steps.Final) {
            goForward3();
        }
    }, [step]);
    return (
        <div className={styles.stepper}>
            <Stepper showStepNumbers={true} presentation={'vertical'} {...stepperProps} />
            <div className={styles.stepperProgress}>
                <div className={styles.stepperProgressFill} style={{ width: `${(step / 4) * 100}%` }} />
            </div>
        </div>
    );
};

export default StepperWrapper;
